module.exports = __webpack_public_path__ + "9226b7a8a1d648dec82b12de02c2b801.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-15.png
// module id = 483
// module chunks = 0